import React, { useEffect } from "react";
import Routes from "./Routes";
import { validateApplaussSession } from "./utils/authValidator";

function App() {
  useEffect(() => {
    // Validate session on app mount
    const checkSession = async () => {
      const result = await validateApplaussSession();

      if (result.valid) {
        if (result.assumedValid) {
          console.log('📱 Session assumed valid (offline or network error)');
        } else if (result.refreshed) {
          console.log('🔄 Session refreshed automatically on app mount:', result.user?.email);
          // Dispatch event to notify components that session was refreshed
          window.dispatchEvent(new CustomEvent('sessionRefreshed', { detail: result.user }));
        } else {
          console.log('✅ Session validated on app mount:', result.user?.email);
        }
      } else {
        // Session invalid or no token
        if (result.reason === 'no_token') {
          console.log('ℹ️ No active session found');
        } else if (result.reason === 'expired' || result.reason === 'refresh_failed') {
          console.log('🚫 Token expired and refresh failed - session invalidated');
        } else if (result.reason === 'invalid_token' || result.reason === 'unauthorized') {
          console.log('🚫 Session invalidated - token was revoked or invalid');
        }
      }
    };

    checkSession();

    // Listen for auth changes (login, logout)
    const handleAuthChange = () => {
      console.log('🔔 Auth changed, validating session...');
      checkSession();
    };

    window.addEventListener('authChanged', handleAuthChange);

    // Cleanup
    return () => {
      window.removeEventListener('authChanged', handleAuthChange);
    };
  }, []);

  return (
    <Routes />
  );
}

export default App;
